module.exports = __webpack_public_path__ + "static/media/8-2.d3090216.mp3";